import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from './ui/alert-dialog';
import { Clock, AlertTriangle } from 'lucide-react';

const SessionTimeoutWarning = ({ isOpen, timeLeft, onExtend, onLogout }) => {
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <AlertDialog open={isOpen} onOpenChange={() => {}}>
      <AlertDialogContent className="max-w-md" onInteractOutside={(e) => e.preventDefault()}>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 text-blue-600">
            <AlertTriangle className="w-6 h-6" />
            Session Expiring Soon
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-4">
            <div className="flex items-center justify-center gap-3 p-4 bg-blue-50 rounded-lg border border-blue-200">
              <Clock className="w-8 h-8 text-blue-600" />
              <div className="text-center">
                <p className="text-3xl font-bold text-blue-600 font-mono">
                  {formatTime(timeLeft)}
                </p>
                <p className="text-sm text-gray-600 mt-1">until automatic logout</p>
              </div>
            </div>
            
            <p className="text-gray-700">
              Your session will expire due to inactivity. You will be logged out automatically
              to protect your account security.
            </p>
            
            <div className="bg-blue-50 p-3 rounded border border-blue-200">
              <p className="text-sm text-gray-700">
                💡 <strong>Tip:</strong> Click "Stay Logged In" to continue your session.
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-2 sm:gap-0">
          <AlertDialogCancel onClick={onLogout} className="bg-gray-100 hover:bg-gray-200">
            Logout Now
          </AlertDialogCancel>
          <AlertDialogAction onClick={onExtend} className="bg-blue-600 hover:bg-blue-700">
            Stay Logged In
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default SessionTimeoutWarning;
